import React from 'react'
import {
    Badge,
    IconButton,
    SvgIcon,
    Tooltip,
    makeStyles,
} from '@material-ui/core'
import DeveloperBoardIcon from '@material-ui/icons/DeveloperBoard';
import Namespace from 'src/constants/locale/Namespace'
import HomePageKeys from 'src/constants/locale/key/HomePage'
import {
    useTranslation,
    useWhiteLabelServiceSettings
} from 'cng-web-lib'
import { useHistory } from 'react-router-dom'
import { RedirectPage } from 'src/common/LayoutCommon';

const useStyles = makeStyles((theme) => ({
    badge: {
        height: 10,
        width: 10,
        borderRadius: 5,
        marginTop: 10,
        marginRight: 5
    },
    popover: {
        width: 320,
        padding: theme.spacing(2)
    },
}))

function DeveloperPortal({
    defaultPagePath
}
) {
    const classes = useStyles()
    const whiteLabelServiceSettings = useWhiteLabelServiceSettings("custom-layout")
    const { translate } = useTranslation(Namespace.HOME_PAGE)
    const translatedTextsObject = makeTranslatedTextsObject()
    const history = useHistory()

    function makeTranslatedTextsObject() {
        let developerPortal = translate(
            Namespace.HOME_PAGE,
            HomePageKeys.DEVELOPER_PORTAL
        )

        return {
            developerPortal
        }
    }

    function redirectPage() {
        let contactUsPath = '/shared/developer-portal'

        let wbContactUsPath;
        if (whiteLabelServiceSettings.length > 0) {
            wbContactUsPath = whiteLabelServiceSettings[0].custom.developerPortalPath
        }

        defaultPagePath = (defaultPagePath == null || defaultPagePath == undefined) ? '/shared/developer-portal' : defaultPagePath;
        RedirectPage(history, contactUsPath,defaultPagePath, wbContactUsPath)
        
    }

    return (
      <Tooltip title={translatedTextsObject.developerPortal}>
        <Badge color='primary' classes={{ badge: classes.badge }}>
          <IconButton onClick={redirectPage}>
            <SvgIcon fontSize='small'>
              <DeveloperBoardIcon />
            </SvgIcon>
          </IconButton>
        </Badge>
      </Tooltip>
    )
}

export default DeveloperPortal;